export default __webpack_public_path__ + "static/media/3.2c22586e.svg";